import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";

import EpgAPI from "../api/epgAPI";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1, 2, 2),
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

export default function EPGModal(params) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openedPopoverId, setOpenedPopoverId] = React.useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickPopover = (event, popoverIdOptionStart) => {
    setOpenedPopoverId(popoverIdOptionStart);
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenedPopoverId(null);
    setAnchorEl(null);
  };

  const actualEPG = params.epgInfo.get(params.epgChannelID);

  let actualDay = [];
  let nextDay = [];
  let next2Day = [];
  let firstDayTextNumber = "";
  let secondDayTextNumber = "";
  let thirdDayTextNumber = "";
  if (actualEPG !== undefined) {
    actualDay = EpgAPI.getEventsForOffsetDay(actualEPG.events, 0);
    nextDay = EpgAPI.getEventsForOffsetDay(actualEPG.events, 1);
    next2Day = EpgAPI.getEventsForOffsetDay(actualEPG.events, 2);

    if (actualDay.length > 0) {
      firstDayTextNumber = EpgAPI.getFirstDayEvent(actualDay);
    }
    if (nextDay.length > 0) {
      secondDayTextNumber = EpgAPI.getFirstDayEvent(nextDay);
    }
    if (next2Day.length > 0) {
      thirdDayTextNumber = EpgAPI.getFirstDayEvent(next2Day);
    }
  }

  const renderEventsForDate = (option, i) => {
    return (
      <div style={{ marginBottom: "2px" }} key={option.start}>
        <p
          style={{ cursor: "pointer", margin: "0px" }}
          onClick={(e) => handleClickPopover(e, option.start)}
        >
          <i>
            {EpgAPI.timestampToHoursMinutes(option.start)} -{" "}
            {EpgAPI.timestampToHoursMinutes(option.end)}
          </i>
          <br />
          {option.title}
        </p>
        <Popover
          open={openedPopoverId === option.start}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          style={{
            maxWidth: "70%",
          }}
        >
          <Typography className={classes.typography}>
            {option.description}
          </Typography>
        </Popover>
      </div>
    );
  };

  return (
    <div
      style={{
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        type="button"
        onClick={handleOpen}
      >
        Toda la programación
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="max-width-dialog-title">Programación</DialogTitle>
        <DialogContent style={{ marginTop: "-15px" }}>
          <Grid container justify="center" spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <h5>{firstDayTextNumber}</h5>
              {actualDay !== undefined &&
                actualDay.map((option, i) => {
                  return renderEventsForDate(option, i);
                })}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <h5>{secondDayTextNumber}</h5>
              {nextDay !== undefined &&
                nextDay.map((option, i) => {
                  return renderEventsForDate(option, i);
                })}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <h5>{thirdDayTextNumber}</h5>
              {next2Day !== undefined &&
                next2Day.map((option, i) => {
                  return renderEventsForDate(option, i);
                })}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}
